export const communityCacheKey = (companyId: number, regionId: number): string =>
  `communities:${companyId}:${regionId}`;